// /**
//  *
//  */
// import { initializeApp } from "firebase/app";
// import { getDatabase } from "firebase/database";
// import {
//   getFirestore,
//   doc,
//   setDoc,
//   collection,
//   addDoc,
//   onSnapshot,
//   query,
//   updateDoc,
//   getDocs,
//   getDoc,
//   writeBatch,
//   orderBy,
//   where,
//   deleteDoc,
// } from "firebase/firestore";
// import {
//   getAuth,
//   onAuthStateChanged,
//   signInWithEmailAndPassword,
//   createUserWithEmailAndPassword,
//   signOut,
//   updateProfile,
// } from "firebase/auth";

// const firebaseConfig = {
//   apiKey: "AIzaSyDaH_EyDxhhB7Emq6qEto6HRevW51wLWgk",
//   authDomain: "online-divergentes.firebaseapp.com",
//   projectId: "online-divergentes",
//   storageBucket: "online-divergentes.appspot.com",
//   messagingSenderId: "851328038892",
//   appId: "1:851328038892:web:db365d881f264f730672c9",
//   measurementId: "G-KVEHCJRX3Y",
// };

// const app = initializeApp(firebaseConfig);
// const db = getFirestore();
// const dbr = getDatabase(app);
// const auth = getAuth();

// export {
//   app,
//   db,
//   dbr,
//   doc,
//   auth,
//   writeBatch,
//   query,
//   getDocs,
//   getDoc,
//   deleteDoc,
//   orderBy,
//   where,
//   setDoc,
//   collection,
//   addDoc,
//   updateDoc,
//   onSnapshot,
//   onAuthStateChanged,
//   signInWithEmailAndPassword,
//   createUserWithEmailAndPassword,
//   updateProfile,
//   signOut,
//   getDatabase,
// };

// Import the functions you need from the SDKs you need
import { getDatabase } from "firebase/database";
import { initializeApp } from "firebase/app";
import {
  getFirestore,
  doc,
  setDoc,
  collection,
  addDoc,
  onSnapshot,
  query,
  updateDoc,
  getDocs,
  writeBatch,
  orderBy,
  where,
} from "firebase/firestore";
import {
  getAuth,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  updateProfile,
} from "firebase/auth";
//import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDOkoMN_y5Pbi10q1WLTQuxHKl7bXWa2Wc",
  authDomain: "com-cgc-api.firebaseapp.com",
  databaseURL: "https://com-cgc-api-default-rtdb.firebaseio.com",
  projectId: "com-cgc-api",
  storageBucket: "com-cgc-api.appspot.com",
  messagingSenderId: "212344780686",
  appId: "1:212344780686:web:27d35c8a58aa53f742d6df",
  measurementId: "G-LD1GRQCPT5",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
//const analytics = getAnalytics(app);
const db = getFirestore();
const dbr = getDatabase(app);
const auth = getAuth();

export {
  app,
  db,
  dbr,
  doc,
  auth,
  writeBatch,
  query,
  getDocs,
  orderBy,
  where,
  setDoc,
  collection,
  addDoc,
  updateDoc,
  onSnapshot,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  updateProfile,
  signOut,
};
